<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>SUPPLY CHAIN REPORT</h4>
			</div>

			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px' }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>Supply Chain</strong></span>
					</div>
					<div>
						<div class="mb-3">   
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<SupplyChainReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

								<el-tab-pane :label="'Item Quota'" :name="'2'">
									<SupplyChainItemQuotaReportTab :tabIndex="'2'" :tabName="'item_quota'" :tabLabel="'Item Quota'"/>
								</el-tab-pane>

							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import SupplyChainReportTab from '@/views/pages/SupplyChainReportTab.vue'
import SupplyChainItemQuotaReportTab from '@/views/pages/SupplyChainItemQuotaReportTab.vue'

export default
{
	extends: Bright,
	components: { 
		SupplyChainReportTab,
		SupplyChainItemQuotaReportTab
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Service Level DC', name: 'supplychain', index: '0' },
				{label:'Tracking Proses PB', name: 'tracking_process_pb', index: '1' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>